import axios from "axios"
const WP_HOME = `https://members.eccourts.org`

export const getOfficeByCategory = async(id) => {
  return axios.get(`${WP_HOME}/wp-json/wp/v2/office?categories=${id}`)
}
export const getCategories = async () => {
  return axios.get(`${WP_HOME}/wp-json/wp/v2/categories?per_page=100`)
}
export const getCategoryPostByType = async (type, id) => {
  console.log(type, id)
  let url =  type ? `${WP_HOME}/wp-json/wp/v2/${type}?categories=${id}&per_page=100` 
                  :  `${WP_HOME}/wp-json/wp/v2/posts/?categories=${id}&per_page=100`
  return axios.get(url)
}